export const closersUrl = '/api/closers-list';

export default {
    closersUrl
}